import { render } from "./Confirmation.vue?vue&type=template&id=50adc632"
const script = {}

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__